import Vue from 'vue';
import Vuetify, { VTextField, VTooltip, VAlert, VAutocomplete, VExpansionPanel, VPagination, VTextarea, VRadioGroup, VDataTable } from 'vuetify/lib';

Vue.use(Vuetify, {
  components: { VTextField, VTooltip, VAlert, VAutocomplete, VExpansionPanel, VPagination, VTextarea, VRadioGroup, VDataTable }
});

export default new Vuetify({
});
